import Swiper from "swiper";
export default function TopSwiper() {
  const mainElement = document.getElementById(`js_top_slide`);
  const topSwiper = mainElement
    ? new Swiper(topSwiperElement, topSwiperOptions)
    : false;
}
//サムネイル

const sliderThumbnail = new Swiper(".slider-thumbnail", {
  slidesPerView: 7
  // spaceBetween: 10
  // watchSlidesProgress: true
});

const topSwiperElement = `.topswiper--container`;
const topSwiperOptions = {
  loop: true,
  speed: 500,
  loopAdditionalSlides: 5,
  autoplay: {
    disableOnInteraction: false,
    delay: 5000
  },
  thumbs: {
    swiper: sliderThumbnail
  },
  navigation: {
    nextEl: ".swiper-button-next", //次へボタン
    prevEl: ".swiper-button-prev" //前へボタン
  }
};
